import React from 'react';

export function WorkVideo(props: {
    video: string;
    maxHeight?: string;
    transform?: string;
    type?: string;
}) {
    const {
        video,
        maxHeight = '1200px',
        transform = 'translateY(-2px)',
        type = 'video/mp4'
    } = props;

    return (
        <div style={{ overflow: 'hidden' }}>
            <video 
                style={{ 
                    width: '100%', 
                    aspectRatio: 'auto', 
                    maxHeight: maxHeight, 
                    transform: transform, 
                    display: 'block' 
                }} 
                loop 
                autoPlay 
                muted 
                playsInline
            >
                <source src={video} type={type} />
                Your browser does not support the video tag.
            </video>
        </div>
    );
}

